import { render, staticRenderFns } from "./TheSendTransactionOfflineLayout.vue?vue&type=template&id=8ae3cb5a"
import script from "./TheSendTransactionOfflineLayout.vue?vue&type=script&lang=js"
export * from "./TheSendTransactionOfflineLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports